// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2023 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import * as React from "react";

const Email: React.FC = () => {
    return <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 60 59"  strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" focusable="false" width="24" height="24" fill="currentColor"><path d="M58.4 10.5H1.6c-.6 0-1 .4-1 1v36c0 .6.4 1 1 1h56.8c.6 0 1-.4 1-1v-36c0-.6-.4-1-1-1zM30 29.6L6.4 13.3h47.2L30 29.6zm26.6-15v31.2H3.4V14.6l26.1 18.2c.3.2.7.2 1.1 0l26-18.2z"/></svg>;
};

export default React.memo(Email);
